import { render, staticRenderFns } from "./index.vue?vue&type=template&id=02f4b634&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=02f4b634&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02f4b634",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/h5-web-gold/h5-web-gold/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('02f4b634')) {
      api.createRecord('02f4b634', component.options)
    } else {
      api.reload('02f4b634', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=02f4b634&scoped=true&", function () {
      api.rerender('02f4b634', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/purchaseOrder/index.vue"
export default component.exports